import React from "react";
import Select from "react-select";

const WorkflowTriggerEdit = ({
                                 data,
                                 selectedTrigger,
                                 updateTrigger,
                                 trigger_configs,
                                 default_trigger_type
                             }) => {


    const styleSelect = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            border: "0 !important",
            boxShadow: state.isFocused ? "0px 0px 10px #F39800 " : "0 !important"
        })
    };

    const triggerDescription = {
        invoice_status_transitions: data.t.read("rule.trigger_description_invoice_status_transitions"),
        expense_status_transitions: data.t.read("rule.trigger_description_expense_status_transitions"),
        is_billable_transition: data.t.read("rule.trigger_description_is_billable_transition"),
        expense_account_submitted: data.t.read("rule.trigger_description_expense_account_submitted")
    };

    const triggerTypeOptions = Object.entries(trigger_configs).map(([value, config]) => ({
        value,
        label: data.t.read(config.labelKey)
    }));

    const selectedTriggerType =
        selectedTrigger.type && trigger_configs[selectedTrigger.type]
            ? selectedTrigger.type
            : default_trigger_type;

    const selectedTriggerConfig = trigger_configs[selectedTriggerType];
    const triggerStateOptions = selectedTriggerConfig.states.map((s) => ({
        value: s,
        label: data.t.read(`rule.trigger_states.${s}`)
    }));

    const initialStateValue =
        selectedTrigger?.initial_state &&
        selectedTriggerConfig.states.includes(selectedTrigger.initial_state)
            ? selectedTrigger.initial_state
            : selectedTriggerConfig.defaultInitial;

    const finalStateValue =
        selectedTrigger?.final_state &&
        selectedTriggerConfig.states.includes(selectedTrigger.final_state)
            ? selectedTrigger.final_state
            : selectedTriggerConfig.defaultFinal;

    const isFixedStatusTrigger = selectedTriggerType === "invoice_status_transitions";

    const FieldLabel = ({children, hint}) => (
        <div className="d-flex align-items-center justify-content-between mb-1">
            <label className="small font-weight-bold m-0">{children}</label>
            {hint ? <span className="text-muted small">{hint}</span> : null}
        </div>
    );

    const SelectField = ({name, options, value, onChange, disabled = false}) => (
        <Select
            name={name}
            options={options}
            value={options.find((o) => o.value === value) || null}
            styles={styleSelect}
            classNamePrefix="select"
            isDisabled={disabled}
            onChange={(choice) => onChange(choice ? choice.value : "")}
        />
    );

    return (
        <div className="d-flex justify-content-center">
            <div className="card shadow-sm border-radius-30 mb-3 border" style={{width: 860}}>
                <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between ">
                        <h5 className="mb-0 text-uppercase">{data.t.read("trigger")}</h5>
                    </div>

                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <FieldLabel>{data.t.read("rule.trigger_type")}</FieldLabel>
                            <SelectField
                                name="trigger-type"
                                options={triggerTypeOptions}
                                value={selectedTriggerType}
                                onChange={(val) => updateTrigger("type", val)}
                            />
                        </div>

                        <div className="col-md-8 mb-3">
                            <FieldLabel>{data.t.read("description")}</FieldLabel>
                            <div className="p-2 rounded" style={{borderColor: "#EEF1F4"}}>
                                <p className="mb-2">{triggerDescription[selectedTriggerType]}</p>
                            </div>
                        </div>
                        
                        {/*<div className="col-md-6 mb-3">*/}
                        {/*    <FieldLabel hint={isFixedStatusTrigger ? data.t.read("locked") : null}>*/}
                        {/*        {data.t.read("rule.trigger_initial_state")}*/}
                        {/*    </FieldLabel>*/}
                        {/*    <SelectField*/}
                        {/*        name="trigger-initial-state"*/}
                        {/*        options={triggerStateOptions}*/}
                        {/*        value={initialStateValue}*/}
                        {/*        disabled={isFixedStatusTrigger}*/}
                        {/*        onChange={(val) => updateTrigger("initial_state", val)}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        
                        {/*<div className="col-md-6 mb-3">*/}
                        {/*    <FieldLabel hint={isFixedStatusTrigger ? data.t.read("locked") : null}>*/}
                        {/*        {data.t.read("rule.trigger_final_state")}*/}
                        {/*    </FieldLabel>*/}
                        {/*    <SelectField*/}
                        {/*        name="trigger-final-state"*/}
                        {/*        options={triggerStateOptions}*/}
                        {/*        value={finalStateValue}*/}
                        {/*        disabled={isFixedStatusTrigger}*/}
                        {/*        onChange={(val) => updateTrigger("final_state", val)}*/}
                        {/*    />*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkflowTriggerEdit;
